/**
 * Slice: Case Study Selector
 *
 * Takes the slice and builds a tab-style selector component
 * for displaying case studies.
 */

import React, { useState, useEffect } from 'react';
// import Image from 'gatsby-image';
import { v1 as uuid } from 'uuid';
import classNames from 'classnames';
import Container from '../container';
import Row from '../row';
import Col from '../col';
import BgImage from 'gatsby-background-image';
import ArrowLink from '../arrow-link';
import styles from './case-study-selector.module.scss';

const CaseStudySelector = ({ slice }) => {
  const [tabSelected, setTabSelected] = useState('');

  useEffect(() => {
    document.getElementById('defaultOpen').click();
  }, []);

  function changeContent(e, loc) {
    setTabSelected(loc);
  }

  /**
   * Build images portion of tabbed content
   *
   * @param item
   * @returns {string|*}
   */
  function buildImages(item) {
    const doc = item.case_study.document;

    if (!doc.data.hero_background_image) {
      return 'Missing Case Study Images';
    }

    return (
      <div className={ classNames({ [styles.imageBox]: true, [styles.imageBoxActive]: tabSelected === doc.uid }) } key={uuid()}>
        <Row gutter={{ base: '3rem', md: '5rem' }}>
          <Col md={12}>
            <BgImage
              className={styles.imageOne}
              fluid={doc.data.hero_background_image.fluid}
            />
          </Col>
        </Row>
        <Row gutter={{ base: '1rem', md: '1rem' }}>
          <Col md={6}>
            {doc.data.slices[0].items[0]
              ? (<BgImage className={styles.imageSecondary} fluid={doc.data.slices[0].items[0].sub_image.fluid} />)
              : ''
            }
          </Col>
          <Col md={6}>
            {doc.data.slices[0].items[1]
              ? (<BgImage className={styles.imageSecondary} fluid={doc.data.slices[0].items[1].sub_image.fluid} />)
              : ''
            }
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <section className={ classNames(styles.section) }>
      <Container>
        <Row gutter={{ base: '3rem', md: '5rem' }}>
          <Col md={6}
            className={ styles.imageBlocks }>
            {slice.items.map(item => buildImages(item))}
          </Col>
          <Col md={6}>
            <Row gutter={{ base: '3rem', md: '5rem' }}>
              <Col md={12} className={ styles.casestudHeader }>
                <h2>{slice.primary.title1.text}</h2>
              </Col>
            </Row>
            <Row gutter={{ base: '1rem', md: '2rem' }}>
              {slice.items.map((item, index) => (
                <Col md={4} key={uuid()}>
                  <button
                    className={ classNames({ [styles.tabButton]: true, [styles.tabButtonActive]: tabSelected === item.case_study.document.uid }) }
                    onClick={(e) => {changeContent(e, item.case_study.document.uid)}}
                    id={index === 0 ? 'defaultOpen' : ''}
                  >
                    <div className={ styles.tabTitle }>{item.case_study.document.data.title.text}</div>
                    <div className={ styles.tabSubtitle }>{item.case_study.document.data.location.text}</div>
                  </button>
                </Col>
              ))}
            </Row>
            <Row gutter={{ base: '3rem', md: '5rem' }}
              className={ styles.offsetCol }>
              <Col md={12}>
                {slice.items.map(item => (
                  <div
                    key={uuid()}
                    className={ classNames({ [styles.tabContent]: true, [styles.tabContentActive]: tabSelected === item.case_study.document.uid }) }
                  >
                    <h3>{item.case_study.document.data.slices[0].primary.case_study_title.text}</h3>
                    <p>{item.case_study.document.data.slices[0].primary.excerpt.text}</p>

                    <ArrowLink
                      to={ item.case_study.document.url }
                      text="Read the case study"
                      arrowType="arrow"
                      arrowPosition="end"
                    />
                  </div>
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default CaseStudySelector;
